<template>
    <generic-view
        id="notifications_container"
        title="Notifications And Alerts"
        :entity_name="entityName"
        :headers="headers"
        :isActive="true"
        :paginated="true"
        :show_clear="true"
        :table_only="table_only"
        :hubMethod="'cms_new_violation'"
        :table_items_per_page="table_items_per_page"
        @entity_posted="reloadData"
        icon="mdi-alert-outline"
         
    >
    </generic-view>
</template>
<script>
import {mapActions} from 'vuex'
export default {
    props:['table_only','table_items_per_page'],
    data() {
        return {
            entityName:"notification",
            headers: [
                {
                    text: 'Message',
                    value: 'message',
                    type: 'textfield',
                },
                /*{
                    text: 'Type',
                    value: 'type',
                    type: 'textfield',
                },*/
                {
                    text: 'User',
                    value: 'user',
                    type: 'multiselect',
                    multiple:false,
                    entity:'user',
                },/*
                {
                    text:'Driver',
                    value:'driver',
                    type:'multiselect',
                    entity:'driver',
                    selector:'selectableInfo',
                    multiple:false,
                    chipColor:"green",
                    hide_client:true
                },*/
                {
                    text:"SignalR",
                    value:"isSignalR",
                    type:'checkbox'
                },/*
                {
                    text:"Date/Time",
                    value:"strCreated",
                    type:'textfield'
                }*/
                
            ]
        }
    },
    methods:{
        ...mapActions('entities',['getEntities']),
        reloadData(){
            this.getEntities(this.entityName)
            this.getEntities('user')
        }
    }
}
</script>